import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { JEService } from 'src/app/services/je-services.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';

@Component({
  selector: 'app-appeal',
  templateUrl: './appeal.component.html',
  styleUrls: ['./appeal.component.scss']
})
export class AppealComponent implements OnInit {

  public appealData: any = null;
  public emailId: String = '';
  public contractorId: any = null;;
  public userId: any = null;
  vendorForm: FormGroup;
  public ipAddress: any = '000.000.000';
  public uploadOptions: any = [];
  documentList: any = [];

  constructor(
    private loader: AppLoaderService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    // private confirmationService: ConfirmationService,
    private _personalDetalSer: FarmersDetailsService,
    // private fApplicationService: FarmersApplicationService,
    private vendorService: VendorDashboardService,
    private cryptoJsService: CryptoJsService,
    private jeService: JEService,
    private formBuilder: FormBuilder,
    private ipService: IpAddressService,
    // private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    this.contractorId = JSON.stringify(token?.officeCode);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const vendorUser = loginDetails.get('vendorUser') ? loginDetails.get('vendorUser') : null;

    if (vendorUser) {
      this.emailId = vendorUser as String;
      this.loadComponentList(this.emailId);
    } else {
      this.getVendorFullDetailsByEmail();
    }

    this.getIP();
    this.vendorForm = this.formBuilder.group({
      documentType: [null, Validators.required],
    });
  }

  getVendorFullDetailsByEmail() {
    this.jeService.getVendorFullDetailsByEmail(this.userId).subscribe({
      next: (data) => {
        this.emailId = data.personalDetails.$values[0].Email_ID;
        this.loadComponentList(this.emailId);
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    });
  }

  loadComponentList(emailId) {
    this.loader.start();
    this.vendorService
      .getVendorApprovalDetails(emailId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if (res.length > 0) {
            this.appealData = res[0];
            this.uploadOptions = JSON.parse(res[0].DocTypeArray_JSON);
          } else {
            this.appealData = [];
            this.messageService.add({
              severity: 'warn',
              summary: 'Info Message',
              detail: `No component found for this vendor. ${res}`,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.appealData = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getIP() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let ipAddress = farmerConfData.get('ipAddress');

    if (ipAddress) {
      this.ipAddress = String(ipAddress);
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;

        farmerConfData.set('ipAddress', this.ipAddress)

        const dataF = JSON.stringify(Array.from(farmerConfData.entries()));
        sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));  
      });
    }
  }


  onUpload(event, docType, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    // const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    // const farmerconfData = new Map(encData);
    // let phNo = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';
    const phNo = this.appealData?.Mobile;

    this.loader.start();
    let document = this.vendorForm.controls['documentType'].value;
    this._personalDetalSer.uploadNewRegFile(data, phNo, document?.DocType).subscribe(
      (resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200) {
          // const docDetail = this.vendorAttachmentData.filter(item => item.Doc_Type === document?.DocType);
          // if( docDetail.length > 0) {
          let reqBody = {
            "Id": document?.Id,
            "Type": "VendorReg"
          }

          let reqBodyAfterEncypt = {
            "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
          }

          this.loader.start();
          this._personalDetalSer.vendorRegFileDelete(reqBodyAfterEncypt).subscribe(
            (res2: any) => {
              this.loader.close();

              if (res2 == "File deleted") {
                this.documentList.push({
                  documentType: document?.DocType,
                  attachmentsDoc: resp.data,
                });
                this.messageService.add({
                  severity: 'info',
                  summary: 'Info',
                  detail: 'Confirm and Submit to update the file.',
                });
              } else {
                this.messageService.add({
                  severity: 'info',
                  summary: 'Info',
                  detail: `File Update Failed. ${res2}`,
                });
              }
            },
            (error: any) => {
              this.loader.close();
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: `File Update Failed. ${error}`,
              });
            }
          )
          // }
          // else {
          // this.documentList.push({
          //   documentType: document?.DocType,
          //   attachmentsDoc: resp.data,
          // });
          // this.messageService.add({
          //   severity: 'success',
          //   summary: 'Success',
          //   detail: 'File Added Successfully',
          // });
          // }

        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Oops! Someting went wrong.',
          });
        }
      },
      (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    );
    uploadElement.clear();
  }

  isImage(path: string): boolean {
    return path
      ? /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/.test(path.toLowerCase())
      : false;
  }

  onSubmitUpdateDoc(){
    let reqBody = {
      Email_ID: this.appealData?.Email_ID,
      InsertAttachments: this.documentList,
      Network_Id: this.ipAddress,
      Terminal_ID: this.ipAddress,
    }

    this.updateVendorRegAttachments(reqBody);
  }

  updateVendorRegAttachments(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this._personalDetalSer.insertVendorRegAttachments(reqBodyAfterEncypt).subscribe({
      next: (data) => {
        this.loader.close();
        if (data.startsWith("Success")) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: data,
          });
          this.loadComponentList(this.emailId);
          this.documentList = [];
          this.vendorForm.reset();
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Info Message',
            detail: `Document not updated. ${data}`,
          });
        }
      },
      error: (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    });
  }

  removeCaptureImg(i) {
    this.documentList.splice(i, 1);
  }
}
